import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Twitter, Instagram } from 'lucide-react';

const socialLinks = [
  { icon: Facebook, label: 'Facebook', href: '#' },
  { icon: Linkedin, label: 'LinkedIn', href: '#' },
  { icon: Twitter, label: 'Twitter', href: '#' },
  { icon: Instagram, label: 'Instagram', href: '#' },
];

export const LandingFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full text-white bg-oxford-blue">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand Column */}
          <div className="lg:col-span-1 space-y-6">
            <img
              src="/images/selise-legal.png"
              alt="SELISE Legal Templates"
              loading="lazy"
              className="h-10 w-auto"
            />
            <p className="text-sm leading-relaxed text-white/70 font-open-sans">
              {t('LANDING_FOOTER_DESCRIPTION')}
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-3">
              {socialLinks.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  className="bg-white/10 px-2 py-1.5 rounded-md text-white/80 hover:text-white transition-colors"
                >
                  <Icon className="h-4 w-4" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* Documents Column */}
          <div>
            <h3 className="mb-5 text-sm font-semibold uppercase tracking-[0.15em] text-white/50 font-bahnschrift">
              {t('LANDING_FOOTER_DOCUMENTS')}
            </h3>
            <ul className="space-y-3">
              {[
                'LANDING_FOOTER_REAL_ESTATE',
                'LANDING_FOOTER_BUSINESS',
                'LANDING_FOOTER_PERSONAL',
                'LANDING_FOOTER_FINANCIAL',
                'LANDING_FOOTER_WORK_EMPLOYMENT',
              ].map((key) => (
                <li key={key}>
                  <Link
                    to="/templates"
                    className="text-sm text-white/70 transition-colors hover:text-white"
                  >
                    {t(key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="mb-5 text-sm font-semibold uppercase tracking-[0.15em] text-white/50 font-bahnschrift">
              {t('LANDING_FOOTER_COMPANY')}
            </h3>
            <ul className="space-y-3">
              {[
                'LANDING_FOOTER_ABOUT_US',
                'LANDING_FOOTER_CONTACT_US',
                'LANDING_FOOTER_HELP_CENTER',
                'LANDING_FOOTER_REVIEWS',
              ].map((key) => (
                <li key={key}>
                  <a
                    href="#"
                    className="text-sm text-white/70 transition-colors hover:text-white"
                  >
                    {t(key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="mb-5 text-sm font-semibold uppercase tracking-[0.15em] text-white/50 font-bahnschrift">
              {t('LANDING_FOOTER_LEGAL')}
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#"
                  className="text-sm text-white/70 transition-colors hover:text-white"
                >
                  {t('LANDING_FOOTER_PRIVACY')}
                </a>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-sm text-white/70 transition-colors hover:text-white"
                >
                  {t('LANDING_FOOTER_TERMS_OF_USE')}
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-white/70 transition-colors hover:text-white"
                >
                  {t('LANDING_FOOTER_DISCLAIMER')}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-white/70 transition-colors hover:text-white"
                >
                  {t('LANDING_FOOTER_COOKIE_POLICY')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Bar */}
        <div className="mt-12 border-t border-white/10 pt-8">
          <p className="text-sm text-white/50">
            {t('LANDING_FOOTER_COPYRIGHT')}
          </p>
        </div>
      </div>

      {/* Disclaimer Bar */}
      <div className="border-t border-white/10 bg-oxford-blue">
        <div className="mx-auto max-w-7xl px-6 py-6 lg:px-8">
          <p className="text-center text-xs leading-relaxed text-white/55 font-open-sans">
            {t('LANDING_FOOTER_DISCLAIMER_TEXT')}
          </p>
        </div>
      </div>
    </footer>
  );
};
